import React from 'react'
import Navbar from '../pages/Navbar'
import gym4 from "../Images/gym4.jpg"
import Footer from '../pages/Footer'
const Trainers = () => {
  return (
    <>
    <Navbar/>
    <img src={gym4} className="rounded" alt="..."/>
    <ul>
      <li className='list'>increased flexibility </li>
<li className='list'>increased muscle strength and tone</li>
<li className='list'>improved respiration, energy and vitality</li>
<li className='list'>maintaining a balanced metabolism</li>
<li className='list'>weight reduction</li>
<li className='list'>cardio and circulatory health</li>
<li className='list'>improved athletic performance</li>
<li className='list'>protection from injury</li>
</ul>
    
     
    <Footer/>
    </>
  )
}

export default Trainers